<div class="flex min-w-0 items-center gap-3">
  @if (email) {
    <p class="hidden min-w-0 max-w-[14rem] truncate text-sm text-slate-600 sm:block">
      {{ email }}
    </p>
  }

  <span
    class="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-200 text-sm font-semibold text-slate-700"
    [attr.aria-label]="displayName"
    [attr.title]="email || displayName">
    @if (pictureUrl; as picture) {
      <img [src]="picture" alt="" class="h-full w-full object-cover" />
    } @else {
      <span>{{ initial }}</span>
    }
  </span>

  <button
    type="button"
    class="inline-flex cursor-pointer items-center gap-1.5 rounded-lg border-0 bg-transparent px-2 py-1.5 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
    (click)="onLogout()">
    <app-svg-icon src="assets/icons/logout.svg" [size]="16" />
    <span class="hidden sm:inline">Sign out</span>
  </button>
</div>
